import React from 'react';
import './Select.scss'; // Importation du fichier SCSS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

const Select = ({ options, onSelect, selectedValue }) => {
  return (
    <div className="select-container">
      <select onChange={(e) => onSelect(options.find(opt=>opt.value === e.target.value))} value={selectedValue} className="custom-select">
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
    </div>
  );
};

export default Select;